var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sub-account-tab", attrs: { id: "sub-account-users-tab" } },
    [
      _c("div", { staticClass: "tab-title" }, [
        _c("div", { staticClass: "tab-title-mian" }, [
          _c(
            "div",
            {
              staticStyle: { width: "fit-content" },
              on: {
                click: function($event) {
                  return _vm.openSubAccountPopup("addUser", "")
                }
              }
            },
            [
              _c("div", {
                staticClass: "icon-util sub-add-user tab-title-icon"
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("language.popup.subAccountPopup.addUser.title"))
                )
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tab-title-sub" }, [
          _c("div", { staticClass: "sub-button", style: _vm.buttonWidth() }, [
            _c("div", {
              staticClass: "icon-util sub-add-folder tab-title-icon",
              on: {
                click: function($event) {
                  return _vm.openSubAccountPopup("addItem", _vm.clickSubAccount)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                on: {
                  click: function($event) {
                    return _vm.openSubAccountPopup(
                      "addItem",
                      _vm.clickSubAccount
                    )
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("language.popup.subAccountPopup.addItemButton"))
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sub-button", style: _vm.buttonWidth() }, [
            _c("div", {
              staticClass: "icon-util sub-quick_assign tab-title-icon",
              on: {
                click: function($event) {
                  return _vm.openSubAccountPopup(
                    "batchAddItem",
                    _vm.clickSubAccount
                  )
                }
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                on: {
                  click: function($event) {
                    return _vm.openSubAccountPopup(
                      "batchAddItem",
                      _vm.clickSubAccount
                    )
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("language.popup.subAccountPopup.quickAssign"))
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tab-body" }, [
        _c(
          "div",
          { staticClass: "main-table" },
          [
            _c(
              "table",
              {
                staticStyle: { width: "100%" },
                attrs: { border: "0", cellpadding: "0", cellspacing: "0" }
              },
              [
                _c("tr", { staticClass: "tab-th" }, [
                  _c("th", { staticStyle: { padding: "0 20px" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.popup.subAccountPopup.users"))
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "el-scrollbar",
              { staticStyle: { height: "calc(100% - 40px)" } },
              [
                _c(
                  "table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { border: "0", cellpadding: "0", cellspacing: "0" }
                  },
                  _vm._l(_vm.userData, function(item, index) {
                    return _c(
                      "tr",
                      {
                        key: index,
                        staticClass: "tab-tr",
                        class:
                          item.emailId == _vm.clickSubAccount
                            ? "tab-tr-hover"
                            : "",
                        on: {
                          click: function($event) {
                            return _vm.getItemList(item)
                          }
                        }
                      },
                      [
                        _c(
                          "td",
                          {
                            staticStyle: { padding: "0 10px 0 20px" },
                            attrs: { title: item.name }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: { width: "150px" },
                                attrs: { title: item.email }
                              },
                              [_vm._v(_vm._s(item.email))]
                            ),
                            _vm._v(" "),
                            item.delId
                              ? _c("div", {
                                  staticClass:
                                    "icon-util remove tab-hover-icon",
                                  attrs: {
                                    title: _vm.$t("language.common.delete")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.openDeletePopup(
                                        "ignore",
                                        true,
                                        item
                                      )
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.subAccount && item.subAccount.status == 2
                              ? _c("div", {
                                  staticClass:
                                    "icon-util reedit tab-hover-icon",
                                  attrs: {
                                    title: _vm.$t("language.leftBanner.edit")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.openSubAccountPopup(
                                        "editUser",
                                        item.subAccount
                                      )
                                    }
                                  }
                                })
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sub-table" },
          [
            _c(
              "table",
              {
                staticStyle: { width: "100%" },
                attrs: { border: "0", cellpadding: "0", cellspacing: "0" }
              },
              [
                _c(
                  "tr",
                  {
                    staticClass: "tab-th",
                    class:
                      _vm.$i18n.locale == "deutsch" ||
                      _vm.$i18n.locale == "japanese" ||
                      _vm.$i18n.locale == "italian"
                        ? "other-tr"
                        : ""
                  },
                  [
                    _c("th", { staticClass: "th-one" }, [
                      _vm._v(
                        _vm._s(_vm.$t("language.popup.subAccountPopup.folders"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "th-two" }, [
                      _c(
                        "div",
                        {
                          staticClass: "table-check-small",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.editAllItemLimits("read")
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "icon-util sub-check",
                            class: _vm.allRead ? "check-small" : "nocheck-small"
                          })
                        ]
                      ),
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t("language.popup.subAccountPopup.read")
                          ) +
                          "\n                        "
                      ),
                      _c(
                        "div",
                        { staticClass: "icon-util question tab-question" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "tab-questionTxt",
                              staticStyle: { left: "530px" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.subAccountPopup.questionTxtRead"
                                  )
                                )
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "th-two" }, [
                      _c(
                        "div",
                        {
                          staticClass: "table-check-small",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.editAllItemLimits("write")
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "icon-util sub-check",
                            class: _vm.allWrite
                              ? "check-small"
                              : "nocheck-small"
                          })
                        ]
                      ),
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t("language.popup.subAccountPopup.write")
                          ) +
                          "\n                        "
                      ),
                      _c(
                        "div",
                        { staticClass: "icon-util question tab-question" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "tab-questionTxt",
                              staticStyle: { left: "618px" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.subAccountPopup.questionTxtWrite"
                                  )
                                )
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "el-scrollbar",
              { staticStyle: { height: "calc(100% - 40px)" } },
              [
                _c(
                  "table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { border: "0", cellpadding: "0", cellspacing: "0" }
                  },
                  _vm._l(_vm.itemData, function(item, index) {
                    return _c(
                      "tr",
                      {
                        key: index,
                        staticClass: "tab-tr",
                        class: [
                          item.id == _vm.clickItemId ? "tab-tr-hover" : "",
                          _vm.$i18n.locale == "deutsch" ||
                          _vm.$i18n.locale == "japanese" ||
                          _vm.$i18n.locale == "italian"
                            ? "other-tr"
                            : ""
                        ],
                        on: {
                          click: function($event) {
                            _vm.clickItemId = item.id
                          }
                        }
                      },
                      [
                        _c(
                          "td",
                          {
                            staticClass: "tr-one",
                            attrs: { title: item.folderName }
                          },
                          [
                            _c("span", [_vm._v(_vm._s(item.folderName))]),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "icon-util remove tab-hover-icon",
                              attrs: {
                                title: _vm.$t("language.common.delete")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.openDeletePopup("", false, item)
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "tr-two" }, [
                          _c(
                            "div",
                            {
                              staticClass: "table-check-small",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.addTableCheck(item, 0)
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "icon-util sub-check",
                                class: item.limits.read
                                  ? "check-small"
                                  : "nocheck-small"
                              })
                            ]
                          ),
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t("language.popup.subAccountPopup.allow")
                              ) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "tr-two" }, [
                          _c(
                            "div",
                            {
                              staticClass: "table-check-small",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.addTableCheck(item, 1)
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "icon-util sub-check",
                                class: item.limits.write
                                  ? "check-small"
                                  : "nocheck-small"
                              })
                            ]
                          ),
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t("language.popup.subAccountPopup.allow")
                              ) +
                              "\n                    "
                          )
                        ])
                      ]
                    )
                  }),
                  0
                )
              ]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-164017d9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-164017d9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_sub_account/tab_users.vue
// module id = null
// module chunks = 